import { useSyncExternalStore } from 'react';

import type { ParamSessionSnapshot, ParameterSession } from './session';

/**
 * 会话 → React 的桥。
 *
 * 直接 `useSyncExternalStore(session.subscribe, ...)`，**不把快照复制进 `useState`**：
 * 复制一份再手动同步必然出现"两份真相"，表现是某个数字比别处慢一拍。
 * 快照的引用稳定性由 `ParameterSession` 保证（没有变化时返回同一个对象）。
 */
export function useParameterSessionSnapshot(session: ParameterSession): ParamSessionSnapshot {
  return useSyncExternalStore(session.subscribe, () => session.getSnapshot(), () =>
    session.getSnapshot(),
  );
}

const NOOP_SUBSCRIBE = (): (() => void) => () => undefined;

/** 会话可能不存在（还没连上飞控）时的版本；两种状态下 getSnapshot 都必须返回稳定值 */
export function useOptionalSessionSnapshot(
  session: ParameterSession | null,
): ParamSessionSnapshot | null {
  return useSyncExternalStore(
    session === null ? NOOP_SUBSCRIBE : session.subscribe,
    () => (session === null ? null : session.getSnapshot()),
    () => (session === null ? null : session.getSnapshot()),
  );
}

